export default "__VITE_ASSET__9ed6dc3f__"